export { default as VERSION } from '../../ember/version.js';
